<template>
    <div class="text-center">
        {{ message || $t('components.loading_message.operation_in_progress') }}
        <v-progress-linear
            indeterminate
            color="primary"
            class="mt-2"
        ></v-progress-linear>
    </div>
</template>

<script>
export default {
    name: "LoadingMessage",

    props: {
        message: {
            type: String
        }
    },
}
</script>

<style scoped>

</style>
